<template>
  <section class="legal-section">
    <component :is="headingTag" class="legal-section__title">
      <span v-if="sectionNumber">{{ sectionNumber }}. </span>{{ section.title }}
    </component>

    <p v-for="(paragraph, index) in toArray(section.paragraphs)" :key="`paragraph-${index}`" class="legal-section__paragraph">
      {{ paragraph }}
    </p>

    <ul v-if="toArray(section.items).length" class="legal-section__list">
      <li v-for="(item, index) in toArray(section.items)" :key="`item-${index}`">{{ item }}</li>
    </ul>

    <p v-for="(paragraph, index) in toArray(section.additional)" :key="`additional-${index}`" class="legal-section__paragraph">
      {{ paragraph }}
    </p>

    <ul v-if="toArray(section.extra_items).length" class="legal-section__list">
      <li v-for="(item, index) in toArray(section.extra_items)" :key="`extra-item-${index}`">{{ item }}</li>
    </ul>

    <p v-for="(paragraph, index) in toArray(section.subparagraphs)" :key="`subparagraph-${index}`" class="legal-section__paragraph">
      {{ paragraph }}
    </p>

    <ul v-if="toArray(section.subitems).length" class="legal-section__list">
      <li v-for="(item, index) in toArray(section.subitems)" :key="`subitem-${index}`">{{ item }}</li>
    </ul>

    <p v-for="(paragraph, index) in toArray(section.more)" :key="`more-${index}`" class="legal-section__paragraph">
      {{ paragraph }}
    </p>

    <ul v-if="toArray(section.more_items).length" class="legal-section__list">
      <li v-for="(item, index) in toArray(section.more_items)" :key="`more-item-${index}`">{{ item }}</li>
    </ul>

    <p v-for="(paragraph, index) in toArray(section.final)" :key="`final-${index}`" class="legal-section__paragraph">
      {{ paragraph }}
    </p>

    <ul v-if="toArray(section.consent_items).length" class="legal-section__list">
      <li v-for="(item, index) in toArray(section.consent_items)" :key="`consent-item-${index}`">{{ item }}</li>
    </ul>

    <p v-if="section.contact" class="legal-section__paragraph">
      {{ section.contact }}
    </p>

    <LegalSectionRenderer
      v-for="(subsection, index) in toArray(section.subsections)"
      :key="`subsection-${index}`"
      :section="subsection"
      :heading-level="nextHeadingLevel"
    />
  </section>
</template>

<script>
export default {
  name: 'LegalSectionRenderer',
  props: {
    section: {
      type: Object,
      required: true,
    },
    sectionNumber: {
      type: String,
      default: '',
    },
    headingLevel: {
      type: Number,
      default: 2,
    },
  },
  computed: {
    headingTag() {
      return `h${Math.min(Math.max(this.headingLevel, 2), 6)}`;
    },
    nextHeadingLevel() {
      return Math.min(this.headingLevel + 1, 6);
    },
  },
  methods: {
    toArray(value) {
      return Array.isArray(value) ? value : [];
    },
  },
};
</script>

<style scoped>
.legal-section {
  margin-top: 1.5rem;
}

.legal-section__title {
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 0.7rem;
  font-size: 1.06rem;
  line-height: 1.35;
}

.legal-section__paragraph {
  color: #334155;
  font-size: 0.95rem;
  line-height: 1.62;
}

.legal-section__list {
  margin: 0.6rem 0 0.9rem 1.1rem;
  color: #334155;
  font-size: 0.95rem;
  line-height: 1.58;
}

.legal-section__list li + li {
  margin-top: 0.3rem;
}
</style>